// AI Transformation Consultancy service page.
import { ArrowRight } from "lucide-react";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import InnerHero from "../../components/InnerHero";
import Reveal from "../../components/Reveal";
import { VIDEOS } from "../../lib/media";

export default function AiConsultancy() {
  return (
    <div className="bg-black">
      <Nav route="inner" />
      <InnerHero
        video={VIDEOS.serviceA}
        eyebrow="Services · Strategy"
        headline="AI strategy that actually"
        italicWord="ships."
        lede="We assess where you are, map where you need to go, and stay embedded until the systems are live."
      />

      <section className="bg-black py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">What this is</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              Strategy without the slideware.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              Most AI strategies live in decks. Ours live in production. We run structured capability
              assessments across your data, your team and your technology stack. Then we build a roadmap
              that is realistic, sequenced and tied to business outcomes.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              We do not hand over a document and walk away. We stay embedded with your leadership through
              vendor selection, team enablement and first delivery.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-black py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">How we work</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              Discovery to roadmap in two weeks.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              We start with structured interviews across your operations, IT and leadership. We review
              your data landscape and identify the highest-value AI opportunities specific to your sector.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              From there we build a phased roadmap, help you select or rule out vendors, and embed a
              senior engineer with your team for the first delivery sprint. Most clients see their first
              production system within eight weeks of engagement start.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-black py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">Right for you if</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              You have tried AI before and it stalled.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              You need a credible AI roadmap for your board or a government customer. You want senior
              technical counsel, not a junior consultant reading from a framework.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              You are in mining, defence, construction, GIS or heavy industry and you need someone who
              understands your operating constraints, not just AI theory.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-black px-6 pb-24">
        <div className="max-w-2xl mx-auto liquid-glass rounded-3xl p-10 text-center">
          <h3 className="font-instrument text-3xl text-white">Ready to build something that lasts?</h3>
          <p className="text-white/60 text-base mt-4">
            Start with a 30-minute discovery call. No slide deck. Just an engineer.
          </p>
          <a
            href="/#contact"
            className="mt-8 inline-flex items-center gap-2 rounded-full px-8 py-3 bg-white text-black text-sm font-medium hover:bg-white/90 transition-colors"
          >
            Book a discovery <ArrowRight size={16} />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
